
import { Component, OnInit, OnDestroy } from '@angular/core';

import { EmailService } from 'src/app/services/integrations/email/email.service';
import { GeneralService } from 'src/app/services/general.service';
import EmailContext from './context-processor';
import ClientProcessor from './client-processor';
import { forkJoin, BehaviorSubject } from 'rxjs';
import { LeadService } from 'src/app/services/client-services/leads.service';
import { ContactsService } from 'src/app/services/client-services/contacts.service';
import { CompaniesService } from 'src/app/services/client-services/companies.service';

import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { EmailFeedService } from 'src/app/services/integrations/email/email-feed.service';
import { isNumber } from 'util';
import { EmailNotificationService } from 'src/app/services/settings-services/email-notification.service';

@Component({
  selector: 'app-email-feeds',
  templateUrl: './email-feeds.component.html',
  styleUrls: ['./email-feeds.component.css']
})
export class EmailFeedsComponent implements OnInit, OnDestroy {
  /** */
  isFetchingMessages: boolean = true;
  isLoadingMore: boolean = false;
  isContextRecieved: boolean = false;

  lastPage: number = 0;

  /** */
  socket: any = null;

  /** */
  clientsProcessor: any;

  isShowRecipients: boolean = false;

  messages: Array<any> = [];
  currentIndex: number = 10;
  default_messages: Array<any> = [];
  threads: any;
  attachments: Array<any>;
  orgId: number;
  userId: any;
  userEmail: string;
  connectedEmail: string = '';

  /** Query Strings */
  query_string: string = ``;
  deal_query_string = `canneverreturnarecord`;
  user_query_string = `-1`;

  /** */
  isSupervisor: boolean = false;
  subordinates_emails$: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  selectedMessage: any;
  context_primary_email: string;
  context_context_name: string;
  filteredEmails: any[];
  constructor(
    private emailFeedService: EmailFeedService,
    private emailService: EmailService,
    private notificationService: EmailNotificationService,
    private leadService: LeadService,
    private contactService: ContactsService,
    private companiesService: CompaniesService,
    private generalService: GeneralService,
    private signUpService: SignupLoginService,
  ) {
    const localstorage_user_data = JSON.parse(localStorage.getItem('currentUser'));
    this.isSupervisor = localstorage_user_data.supervisor;
    this.userEmail = this.generalService.user.email;
    this.userId = localstorage_user_data.user.id;
  }

  ngOnInit() {
    this.currentIndex = 10
    this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string, this.lastPage);
    this.userId = this.emailService.user_id;
    this.orgId = this.emailService.org_id;
    this.clientsProcessor = ClientProcessor;

    this.socket = this.notificationService.get_socket();
    this.socket.on('email:new', email => {
      const { metadata, service, headers, body } = email;
      let allEmailsToRecieve = [];
      let user_id = ''; 
      //Gmail Services
      if (service == "gmail") {
        const { cc = [], bcc = [], to = '', from = '', sender = {} } = { ...body, ...headers };
        allEmailsToRecieve = [...cc, ...bcc, ...[to], ...[from]];
        user_id = sender.user_id;
      } 
      
      //Outlook Services
      else if (service === "office") {
        const { cc = [], bcc = [], replyTo = [], from = [], to = [], user_id: id } = metadata;
        allEmailsToRecieve = [...cc, ...bcc, ...to, ...from, ...replyTo];
        allEmailsToRecieve = allEmailsToRecieve.map(user => user.address);
        user_id = id;
      }
      const getSubs = () => {
        return new Promise((resolve, reject) => {
          if (this.isSupervisor) {
            this.signUpService.fetchSubordinates(this.userEmail).subscribe((response: any) => {
              let sub_emails = response.map(subordinate => subordinate.email);
              let sub_ids = response.map(subordinate => subordinate.id);
              resolve({ userIds: sub_ids, userEmails: sub_emails })
            });
          } else {
            resolve({ userIds: [], userEmails: [] });
          }
        })
        
      }

      getSubs().then((response: any) => {
        const checkEmails = [this.userEmail, ...response.userEmails];
        const checkIds = [this.userId, ...response.userIds];
        const emailExist = checkEmails.some((v) => allEmailsToRecieve.includes(v));
        if (checkIds.includes(user_id) || emailExist) {
          this.emailFeedService.handleNewMessage(email)
        }
      });

    });

    this.emailService.emailToActOn.subscribe((email: any) => {
      if (Object.keys(email).length) {
        switch (email.type) {
          case 'reply':
            this.reply(email);
            break;
          case 'view':
            this.viewMessage(email);
            break;
          default:
        }
      }
    })

    this.emailService.user_data.subscribe(data => {
      if (!Object.keys(data).length) return;
      this.connectedEmail = data.service_key || '';
    });

    this.emailService.new_email.subscribe(data => {
      if (!this.generalService.checkIfObjectIsEmpty(data)) {
        this.emailFeedService.handleNewMessage(data);
      }
    });

    this.emailFeedService.default_messages.subscribe(messages => {
      this.setMessages(messages);
    });

    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalService.checkIfObjectIsEmpty(context) && !this.isContextRecieved) {
        this.isContextRecieved = true;
        const context_data = this.emailFeedService.
        process_context_data(context);
        console.log('context data', context_data)
        this.context_primary_email = context_data.context_primary_email
        this.context_context_name = context_data.context_name
        this.emailService.context_primary_email_address.next(context_data.context_primary_email);
        console.log('context', context_data)
        const email_list: Array<string> = [context_data.context_primary_email, ...context_data.context_email_list];

        switch (context_data.context_name) {
          case 'lead': 
            this.query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;     
            this.user_query_string = `${this.userId}`;
            this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            break;
          case 'contact':
              this.query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;     
                this.user_query_string = `${this.userId}`;
                this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            break;
          case 'deal':
            // this.query_string = `${email_list.join()}`;
            // this.deal_query_string = `${context_data.context_entity_id}`;
            // this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            this.query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;
            this.signUpService.fetchSubordinates(context_data.context_primary_email).subscribe((response: any) => { 
              this.query_string = `${this.query_string}`;
              this.user_query_string = `${this.user_query_string}`;
              this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            }, err => {
              this.isFetchingMessages = false
            });
            break;
          case 'salesperson':
            if (!this.isSupervisor && context_data.context_entity_id == this.userId) {
              this.query_string = `${context_data.context_primary_email}`;
              this.user_query_string = `${this.userId}`;
              this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            } else if (this.isSupervisor) { // I am a suprvisor
              this.query_string = `${context_data.context_primary_email}`;

              if (context_data.context_entity_id == this.userId) { // I am the salesperson in context
                this.user_query_string = `${this.userId}`;
                this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
                break;
              }

              // I am not the salesperson in context
              this.signUpService.fetchSubordinates(this.userEmail).subscribe((response: any) => {
                for (let i in response) {
                  const subordinate = response[i];
                  if (context_data.context_primary_email == subordinate.email.toLowerCase()) {
                    this.user_query_string = `${subordinate.id}`;
                    this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
                    break;
                  }
                }
              }, err => {
                this.isFetchingMessages = false;
              });
            }

            break;
          case 'dashboard':
            this.query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;
            this.user_query_string = `${this.userId}`;

            if (this.isSupervisor) {
              this.signUpService.fetchSubordinates(context_data.context_primary_email).subscribe((response: any) => {
                let sub_emails = response.map(subordinate => subordinate.email);
                let sub_ids = response.map(subordinate => subordinate.id);

                this.query_string = `${this.query_string},${sub_emails.join()}`;
                this.user_query_string = `${this.user_query_string},${sub_ids.join()}`;
                this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
              }, err => {
                this.isFetchingMessages = false
              });
            } else {
              this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            }
            break;
          case 'company':
            this.query_string = `${context_data.context_primary_email},${(this.emailService.getUserData()).serviceKey || ''}`;     
            this.user_query_string = `${this.userId}`;
            this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            break;
          case 'team':
            this.query_string = `${email_list.join()}`;
            this.fetch_relevant_emails(this.query_string, this.user_query_string, this.deal_query_string);
            break;
          default:
        }

      }
    });

  }

  ngOnDestroy() {
    // this.emailService.email_context.unsubscribe();
    // this.emailService.new_email.unsubscribe();
    this.subordinates_emails$.complete();
    this.subordinates_emails$.unsubscribe();
  }

  check_if_thread_has_lead(index = 0) {
    if (!this.messages || this.messages.length <= index) return;

    const message = this.messages[index];
    if (!message) {
        console.warn(`No message found at index ${index}`);
        return;
    }
    const { recipient = '', cc_recipients = [], bcc_recipients = [] } = message;

    const emailList = [recipient, ...cc_recipients, ...bcc_recipients].filter(email => email);

    const query_string = `email=${emailList.join()}`;

    this.leadService.filterLead(query_string).subscribe((response: any) => {
        if (response && response.success) {
            if (this.messages[index]) {
                this.messages[index].has_lead = !!response.payload.length;
            }
            this.check_if_thread_has_lead(index + 1);
        }
    });
}

  closeEmailView() {
    const emailViewModal = document.getElementById('viewEmailModal');
    emailViewModal.style.display = "none";
    this.selectedMessage = {};
  }



  fetch_relevant_emails(general_query, user_query, deal_query, page = 0, population = 10) {
    const user_email = this.connectedEmail.toLocaleLowerCase();
    this.emailFeedService
        .fetch_emails(user_email, general_query, user_query, deal_query, page, population)
        .subscribe(
            (response: any) => {
                this.isFetchingMessages = false;
                this.isLoadingMore = false;
                this.lastPage += 1;
            },
            (error) => {
                console.error('Error in fetch_relevant_emails:', error);
                this.isFetchingMessages = false;
                this.isLoadingMore = false;
            }
        );
  }
  
  displayFeedItems() {
    let all_items = [...this.messages];
    all_items.sort((a, b) => b.date - a.date);
    if ((this.context_context_name === 'contact' || this.context_context_name === 'company' || this.context_context_name === 'lead') && !this.context_primary_email) {
        return [];
    }
     this.filteredEmails = all_items; 
    if ((this.context_context_name === 'contact' || this.context_context_name === 'company' || this.context_context_name === 'lead') && this.context_primary_email) {
        this.filteredEmails = all_items.filter(email => 
            email.metadata.from.address === this.context_primary_email || 
            email.metadata.to.some(recipient => recipient.address === this.context_primary_email)
        );
        if (this.context_context_name === 'company' && this.context_primary_email) {
        }
    }
    return (this.context_context_name === 'contact' || this.context_context_name === 'company' || this.context_context_name === 'lead') 
        ? this.filteredEmails.slice(0, this.currentIndex) 
        : all_items.slice(0, this.currentIndex);
}

filterMails(needle: string) {
    let filtered_messages: any[] = [];
    if (!needle.trim()) {
        this.messages = [...this.default_messages];
        return;
    }
    for (let i in this.default_messages) {
        const message = this.default_messages[i];
        const { recipient, cc_recipients, bcc_recipients, subject, from } = message;
        const cc: string[] = cc_recipients || [];
        const bcc: string[] = bcc_recipients || [];
        const ccArray = Array.isArray(cc) ? cc : [cc];
        const bccArray = Array.isArray(bcc) ? bcc : [bcc];
        const recipients: string[] = [recipient, ...ccArray, ...bccArray, from];
        const haystack: string = `${recipients.join()}${subject}`.toLocaleLowerCase();
        if (haystack.includes(needle.toLowerCase())) {
            filtered_messages.push(message);
        }
    }
    this.messages = filtered_messages;
}

loadMoreMails() {
    this.isLoadingMore = true;
    const batchSize = 10;
    const startIndex = this.messages.length;
    const currentIndex = this.currentIndex;
    this.currentIndex += batchSize;
    this.emailFeedService.default_messages.subscribe(newMessages => {
        this.messages.push(...newMessages.slice(startIndex, currentIndex + batchSize));
        this.isLoadingMore = false;
    });
} 

  reply(message) {
    const { thread } = message;
    const threadInfo = {
      dealId: thread && thread.deal ? thread.deal.id : '-1',
      deal: thread ? thread.deal : {},
      thread_db_id: thread ? thread._id : ''
    }

    this.selectedMessage = { ...message, ...threadInfo };
    this.updateMessageReadStatus(this.selectedMessage);
    this.emailService.selectedEmail.next(this.selectedMessage);
    this.closeEmailView();
  }

  setMessages(messages) {
    this.messages = messages;
    this.default_messages = messages;
  }

  toggleShowRecipients() {
    this.isShowRecipients = !this.isShowRecipients;
  }

  updateMessageReadStatus(message: any) {
    if (message.status === 'read') return;

    const { index } = message;
    if (!isNumber(index)) return;

    this.emailFeedService.updateMessageReadStatus(message, index);
  }

  /** */

  viewMessage(message) {
    this.selectedMessage = {
      ...message,
      dealId: message.thread && message.thread.deal ? message.thread.deal.id : '-1',
      dealName: message.thread && message.thread.deal ? message.thread.deal.name : '',
    };

    this.attachments = [];
    this.selectedMessage.attachments.forEach(attachment => {
      const { name } = attachment;
      if (name) {
        this.attachments.push({
          ...attachment,
          shortname: `${name.substr(0, 4)}...${name.substr(-6)}`,
        });
      }
    });

    const { recipient, cc_recipients, bcc_recipients, service } = this.selectedMessage;
    if (service === 'mailgun') {
      const { headers: { recipient: mailgunRecipent } } = this.selectedMessage;
      this.clientsProcessor.fetch_clients_information(
        [mailgunRecipent, ...cc_recipients, ...bcc_recipients],
        this.leadService, this.contactService, this.companiesService
      );
    } else {
      this.clientsProcessor.fetch_clients_information(
        [recipient, ...cc_recipients, ...bcc_recipients],
        this.leadService, this.contactService, this.companiesService
      );
    }

    this.emailService.filterAttachments(`thread_id=${this.selectedMessage.thread_id}`).subscribe((res: any) => {
      if (res.success) {
        const attachments = {};
        res.payload.forEach(attachment => {
          const name = attachment.name;
          attachments[name] = {
            ...attachment,
            shortname: name.length > 20 ? `${name.substr(0, 4)}...${name.substr(-6)}` : name,
          }
        });

        this.attachments = [
          ...this.attachments,
          ...Object.keys(attachments).map(key => attachments[key])
        ];

        this.emailFeedService.mailAttachments.next(this.attachments);
      }
    });

    this.updateMessageReadStatus(this.selectedMessage);
    //
    const emailViewModal = document.getElementById('viewEmailModal');
    emailViewModal.style.display = "flex";

  }

}
